import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconX: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke={color ?? "#CBD5E1"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
